module.exports = __webpack_public_path__ + "static/img/Frame3465768.4a952f76.png";